import {TabConfigStructure} from "../tab-config-structure";

export class WorkMaterializationConfig {

  bookConfig: TabConfigStructure[] = [];

}
